import React from 'react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

const sizeClasses = {
  lg: 'px-10 py-4 text-sm',
  md: 'px-8 py-3 text-sm',
  sm: 'px-4 py-2 text-xs',
  full: 'w-full h-12 text-sm mt-8',
};

const variantClasses = {
  gradient:
    'bg-gradient-to-r from-[#6B5CE7] to-[#4ECDC4] text-white font-bold uppercase tracking-wider h-auto rounded-lg hover:shadow-lg hover:shadow-[#6B5CE7]/35 transition-all hover:-translate-y-0.5 disabled:opacity-40',
  solid:
    'bg-[#7B6FE8] text-white hover:bg-[#6B5CE7] font-medium',
  wizard:
    'text-white font-bold uppercase tracking-wider rounded-lg hover:opacity-90 disabled:opacity-50 disabled:cursor-not-allowed',
};

const barlow = { fontFamily: "'Barlow Condensed', sans-serif" };
const wizardBg = { background: 'linear-gradient(135deg, #6B5CE7, #4ECDC4)', fontFamily: "'Barlow Condensed', sans-serif" };

/**
 * ThemedButton — branded button used across Players Health.
 *
 * @param {"gradient"|"solid"|"wizard"} variant  Visual style (default "gradient")
 * @param {"lg"|"md"|"sm"|"full"}       size     Size preset (default "md")
 * @param {string}                      className Extra Tailwind classes
 * @param {React.ReactNode}             children  Button label / content
 *
 * Everything else (onClick, disabled, data-testid, type…) is forwarded to the
 * underlying Shadcn <Button>.
 */
export const ThemedButton = ({
  variant = 'gradient',
  size = 'md',
  className,
  children,
  ...props
}) => {
  const isWizard = variant === 'wizard';

  return (
    <Button
      className={cn(
        variantClasses[variant] || variantClasses.gradient,
        sizeClasses[size] || sizeClasses.md,
        className,
      )}
      style={isWizard ? wizardBg : variant === 'solid' ? undefined : barlow}
      {...props}
    >
      {children}
    </Button>
  );
};

export default ThemedButton;
